import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {catchError, tap} from "rxjs/operators";
import {of} from "rxjs/observable/of";
import {_throw} from "rxjs/observable/throw";
import {App, NavController} from "ionic-angular";
import {NotificationProvider} from "../providers/notification/notification";
import { CompanyProvider } from "../providers/company/company";

@Injectable()

export class ApiInterceptor implements HttpInterceptor {
	get navCtrl(): NavController {
		return this.app.getRootNav();
	}

	constructor(private app: App, private notif: NotificationProvider, private companyProvider: CompanyProvider) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			tap(evt => of(evt)),
			catchError(error => {
				if (error.status === 403) {
					if(this.navCtrl) {
						this.companyProvider.logout().then(() => {
							this.navCtrl.setRoot("LoginPage");

							this.notif.showErrorMessage("Du har blivit utloggad. Vänligen logga in igen.");
						});

						return _throw(null);
					}

					return _throw(error);
				} else {
					return _throw(error);
				}
			}));
	}
}


// WEBPACK FOOTER //
// ./src/interceptors/ApiInterceptor.ts